import React from 'react';
import styled from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoFaqWithImg from 'eco-design/sections/eco-faq-win-img';
import MinTitle from '../MinTitle';
import { useGlobal } from '@/utils/useGlobal';

interface StepPortalProps {
    pageType: string;
}
const euPages = ['normal', 'ultra', 'ac'];

function Explore() {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="direction-right">
                <path id="Vector" d="M8 5.58398L13 10.584L8 15.584" stroke="#477BEA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    );
}
const linkObj: any = {
    eu: 'https://www.ecoflow.com/eu/oasis-home-energy-management-system',
    fr: 'https://www.ecoflow.com/fr/oasis-home-energy-management-system',
    de: 'https://www.ecoflow.com/de/oasis-home-energy-management-system',
    it: 'https://www.ecoflow.com/it/oasis-home-energy-management-system',
    es: 'https://www.ecoflow.com/es/oasis-home-energy-management-system',
    uk: 'https://www.ecoflow.com/uk/oasis-home-energy-management-system',
};

const langConfig: any = {
    us: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746179197558/Frame%201612707540.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1746179197558/Frame%201612707540.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746179197558/Frame%201612707540.jpg',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746179197731/Frame%201612707541.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1746179197731/Frame%201612707541.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746179197731/Frame%201612707541.jpg',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1746179197397/Frame%201612690264.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1746179197397/Frame%201612690264.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1746179197397/Frame%201612690264.jpg',
        },
    },
    eu: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745479867300/Status%20Overview%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745479867300/Status%20Overview%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479957896/Status%20Overview%20(2).png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745479867071/Savings%20Calendar%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745479867071/Savings%20Calendar%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479957689/Savings%20Calendar%20(2).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745479866864/Remote%20Control%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745479866864/Remote%20Control%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479957553/Remote%20Control%20(2).png',
        },
    },
    de: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478016326/Status%20Overview_de.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478016326/Status%20Overview_de.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745478947246/Status%20Overview_de%20(1).png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478016515/Savings%20Calendar_de.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478016515/Savings%20Calendar_de.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745478947443/Savings%20Calendar_de%20(1).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478016121/Remote%20Control_de.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478016121/Remote%20Control_de.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745478947058/Remote%20Control_de%20(1).png',
        },
    },
    fr: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478416218/Status%20Overview_fr%20(1).png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478416218/Status%20Overview_fr%20(1).png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479126158/Status%20Overview_fr%20(2).png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478416428/Savings%20Calendar_fr.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478416428/Savings%20Calendar_fr.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479125768/Savings%20Calendar_fr%20(1).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478416046/Remote%20Control_fr.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478416046/Remote%20Control_fr.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479126005/Remote%20Control_fr%20(1).png',
        },
    },
    it: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478133756/Status%20Overview_it.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478133756/Status%20Overview_it.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745462008871/%E5%A4%A9%E6%B0%94%E9%A2%84%E6%B5%8B.png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478133937/Savings%20Calendar_it.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478133937/Savings%20Calendar_it.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479312288/Savings%20Calendar_it%20(1).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478133364/Remote%20Control_it.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478133364/Remote%20Control_it.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479311973/Remote%20Control_it%20(1).png',
        },
    },
    es: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478555886/Status%20Overview_es.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478555886/Status%20Overview_es.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479446571/Status%20Overview_es%20(1).png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478556065/Savings%20Calendar_es.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478556065/Savings%20Calendar_es.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479446754/Savings%20Calendar_es%20(1).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478555667/Remote%20Control_es.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478555667/Remote%20Control_es.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479446754/Savings%20Calendar_es%20(1).png',
        },
    },
    uk: {
        item1: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478651931/Status%20Overview_uk.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478651931/Status%20Overview_uk.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479544011/Status%20Overview_uk%20(1).png',
        },
        item2: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478652376/Savings%20Calendar_uk.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478652376/Savings%20Calendar_uk.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479543835/Savings%20Calendar_uk%20(1).png',
        },
        item3: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1745478652159/Remote%20Control_uk.png',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1745478652159/Remote%20Control_uk.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1745479544158/Remote%20Control_uk%20(1).png',
        },
    },
};
export default function StepPortal({ pageType = 'normal', ...props }: StepPortalProps) {
    const { locale } = getLocal();
    const { gtm } = useGlobal();
    const { t } = useLang('theProduct.StepPortal');

    const handlerLink = () => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'jump_button',
                position: 'Inpage',
                button_name: t('oasis'),
                url: linkObj[locale],
            });
        } catch (error) {
            console.log(error, 'error-158');
        }
        window.open(linkObj[locale], '_blank');
    };
    const currentLangConfig = langConfig[locale] || {};

    return (
        <section id="StepPortal" className={`${styled.StepPortal} GtmModuleData-section`} data-section-id="StepPortal" data-section-title={t('title')}>
            <div className="stepPortal-container">
                {euPages.includes(pageType) && <MinTitle title={t('save_easy')} align="center" />}

                <div className="title">{t('title')}</div>
                <EcoFaqWithImg
                    theme="black"
                    className="stepPortal-eco-faq"
                    dataLayerTab={{
                        event: 'uaEvent',
                        event_name: 'product_detail_page',
                        list_name: t('title'),
                    }}
                    items={[
                        {
                            desc: t('item1_desc'),
                            pc: currentLangConfig.item1?.pc,
                            h5: currentLangConfig.item1?.h5,
                            title: t('item1_title'),
                        },
                        {
                            desc: t('item2_desc'),
                            pc: currentLangConfig.item2?.pc,
                            h5: currentLangConfig.item2?.h5,

                            title: t('item2_title'),
                        },
                        {
                            desc: t('item3_desc'),
                            pc: currentLangConfig.item3?.pc,
                            h5: currentLangConfig.item3?.h5,

                            title: t('item3_title'),
                        },
                    ]}
                />
                {pageType !== 'na' && (
                    <div className="explore-oasis" onClick={handlerLink}>
                        {t('oasis')} <Explore />
                    </div>
                )}
            </div>
        </section>
    );
}
